<template>
    <div class="DashboardPage">
        <v-content class="pt-2 pl-2">
            <v-row dense>
                <v-col v-if="activeTab=='Discover'" cols="12" md="12">
                    <v-responsive class="overflow-y-auto">
                        <v-responsive height="100%">
                            <v-card v-for="(currentDiscoveredItem, i) in currentDiscoveredItems" :key="i">
                                <quick-preview :item="currentDiscoveredItem.data" :itemId="currentDiscoveredItem.id" :type="currentDiscoveredItem.type"></quick-preview>
                            </v-card>
                            <v-card v-if="!noMoreItemsToDiscover&&loadingItems" class="align-center text-center justify-center">
                                <v-progress-circular
                                color="primary"
                                indeterminate
                                :size="64"
                                ></v-progress-circular>
                            </v-card>
                            <v-card v-if="!noMoreItemsToDiscover&&!loadingItems" v-intersect="onIntersect"
                            class="align-center text-center justify-center"
                            >
                                <!-- INTERSECTION CARD TO LOAD MORE ITEMS WHEN REACHED/IS ON SCREEN -->
                            </v-card>
                            <v-card v-if="noMoreItemsToDiscover" class="align-center text-center justify-center">
                                <v-card-text>No new items to discover, refresh load more</v-card-text>
                                <v-btn icon @click.stop="initialDiscover()">
                                    <v-icon color="primary">mdi-refresh</v-icon>
                                </v-btn>
                            </v-card>
                        </v-responsive>
                    </v-responsive>
                </v-col>

                <v-col v-if="activeTab=='Message'" cols="12" md="12">
                    <chat-list
                    v-if="!loadingChats"
                    :chats="localChats"
                    >

                    </chat-list>

                    <v-progress-circular
                    v-if="loadingChats"
                    color="primary"
                    indeterminate
                    ></v-progress-circular>
                </v-col>

                <v-col v-if="activeTab=='News'" cols="12" md="12">
                    <v-container>
                        <v-card class="fill-height">
                            <v-toolbar
                                color="primary"
                                dark
                            >
                                <v-toolbar-title>Latest News</v-toolbar-title>

                                <v-spacer></v-spacer>

                                <v-icon>mdi-newspaper</v-icon>                            
                            </v-toolbar>
                            <RSSViewer></RSSViewer>
                        </v-card>
                    </v-container>
                </v-col>
            </v-row>
        </v-content>

        <v-bottom-navigation app
        v-model="activeTab"
        color="primary"
        grow
        fixed
        >
        <v-btn value="Discover">
            <span>Discover</span>
            <v-icon>mdi-magnify</v-icon>
        </v-btn>
    
        <v-btn value="Message">
            <v-badge
            v-if="getNumberUnread > 0"
            color="red"
            :content="getNumberUnread"
            >
                Messages
            </v-badge>
            <span v-if="!(getNumberUnread > 0)">Messages</span>
            <v-icon>mdi-message</v-icon>
        </v-btn>
    
        <v-btn value="News">
            <span>Latest News</span>
            <v-icon>mdi-newspaper</v-icon>
        </v-btn>
    
        </v-bottom-navigation>

    </div>
</template>

<script>
import TreatmentDataService from './../services/treatmentDataService.js'
import QuickPreview from './../components/Treatments/Preview/QuickPreview.vue'
import RSSViewer from './../components/News/RSS Viewer/RSSViewer.vue'
import ChatList from './../components/Chat/ChatList.vue'
import fb from '@/fb'
import Toast from './../plugins/customToast.js';

export default {
    name: 'dashboardPage',
    components: {
        QuickPreview,
        ChatList,
        RSSViewer
    },
    props: {
        params: Object
    },
    methods: {
      pushRoute(route){
        this.$router.push({ name: route.name, params: { user: this.$route.params.user, loggedInStatus: this.$route.params.loggedInStatus, userDb: this.userDb, orgDb: this.orgDb} });
      },
      toTop () {
        this.$vuetify.goTo(0)
      },
      onIntersect (entries) {
          //(entries, observer)
        var isIntersecting = entries[0].isIntersecting;

        if (isIntersecting)
        {
            this.discoverNewItem();
        }
      },
      initialDiscover(){
          //Reset the discover page information
          this.selectedCollection = "";
          this.currentDiscoveredItems = [];
          this.noMoreItemsToDiscover = false;
          this.loadingItems = false;

          this.toTop();
          this.discoverNewItem();

      },
      discoverNewItem(){
        if (!this.noMoreItemsToDiscover && !this.loadingItems){
            const collections = ['cases', 'treatments'];
            this.selectedCollection = collections[Math.floor(Math.random() * collections.length)];

            var that = this; //Can this be addressed with anonymous functions instead????!?!?!?!

            //Put in an empty random interests for now until we have that added to the User/Profile page
            var currentIdList = this.currentDiscoveredItems.map(x => x.id);

            this.loadingItems = true;
            this.treatmentService.getRandomByInterests(this.selectedCollection, [], 3, currentIdList)
            .then(function(randomItems){
                if (randomItems.length === 0)
                {
                    that.noMoreItemsToDiscover = true;
                } else {
                    var returnedItems = randomItems.map(x => ({id: x.id, data: x.data, type: that.selectedCollection}));
                    //This will be a list, not a single item --> Manage this by having a list of currentDiscoveredItems... These will then be handled by our scrolling list component (Just multiple of our QuickPreviewComponents)
                    that.currentDiscoveredItems.push(...returnedItems);
                }
                that.loadingItems = false;
            }).catch(function(error){
                if (error === "Could not find any documents")
                {
                    that.noMoreItemsToDiscover = true;
                } else {
                    Toast.fire({  icon: 'error',  title: `Unable to discover new items: ${error}`});
                }
                that.loadingItems = false;
            });
        }
      },
      load(){
        //First initialise the data service
        this.treatmentService = new TreatmentDataService(this.$route.params.userDb);

        //Set the DB's locally so we can update them retrospectively (refresh them)
        this.userDb = this.$route.params.userDb;
        this.orgDb = this.$route.params.orgDb;

        this.initialDiscover();

        this.loadChatList();
      },
      loadChatList(){
          this.loadingChats = true;
            //Could get the whole list (by id, looping through with many queries), that way I have the entire list --> Get the 10 most recent ones?
            //Do one for group using array-contains
            fb.db.collection("chats").where("users", "array-contains", this.userDb.uid).onSnapshot(querySnapshot => {
                var chats = [];
                querySnapshot.forEach(function(doc){
                    chats.push({id: doc.id, data: doc.data()})
                });
                this.localChats = chats;
                this.loadingChats = false;
            })
        },
    },
    computed: {
        getNumberUnread(){
            var unreadCounter = 0;

            if(this.localChats && this.localChats.length > 0){
                this.localChats.forEach(chat => {
                    if (!chat.data.read.includes(this.userDb.uid)){
                        unreadCounter++;
                    }
                });
            }

            return unreadCounter
        }
    },
    created() {
        this.load();
    },
    data: () => ({
        items: [
        { title: 'My Treatments', icon: 'mdi-file-account', route: { path: '/myTreatmentsPage', name: 'MyTreatmentsPage' }, flavourText: "Keep track of your own work", subText: "Search and view treatments completed by yourself and others in your organisation!", image: require('../assets/DashboardPage/myTreatmentImage.jpg') },
        { title: 'Community Treatments', icon: 'mdi-account-group', route: { path: '/communityTreatmentsPage', name: 'CommunityTreatmentsPage' }, flavourText: "Learn off others", subText: "Search through the collection of documented treatments from other Dental Practitioners", image: require('../assets/DashboardPage/communityTreatmentsImage.jpg') },
        { title: 'Treatment Reference', icon: 'mdi-file-document', route: { path: '/treatmentReferencePage', name: 'TreatmentReferencePage' }, flavourText: "NHS Treatment Reference", subText: "Search through treatment references to discover solutions", image: require('../assets/DashboardPage/treatmentReferenceImage.jpg') },
        { title: 'Medicine Reference', icon: 'mdi-pill', route: { path: '/medicineReferencePage', name: 'MedicineReferencePage' }, flavourText: "NHS Medicine Reference", subText: "Search through medicine references to sharpen knowledge needed for administering", image: require('../assets/DashboardPage/medicineReferenceImage.jpg') },
      ],
      userDb: {},
      orgDb: {},
      loadingItems: false,
      treatmentService: null,
      activeTab: "Discover",
      currentDiscoveredItems: [],
      noMoreItemsToDiscover: false,
      selectedCollection: "",
      localChats: [],
      loadingChats: false
    })
}
</script>

<style scoped>
.v-card--reveal {
align-items: center;
bottom: 0;
justify-content: center;
opacity: .5;
position: absolute;
width: 100%;
}
</style>
